import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hidden 2xl:block overflow-x-auto" }
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_3 = { class: "bg-white dark:bg-black divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_4 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white text-center" }
const _hoisted_5 = { class: "text-xs sm:text-sm font-medium" }
const _hoisted_6 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_7 = { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_8 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_9 = { class: "px-3 sm:px-6 py-4 text-sm text-center text-gray-900 dark:text-white" }
const _hoisted_10 = { class: "font-medium text-xs sm:text-sm" }
const _hoisted_11 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_12 = { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_13 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_14 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 text-center" }
const _hoisted_15 = { class: "flex items-center justify-center space-x-1 lg:space-x-2" }
const _hoisted_16 = { class: "relative group inline-block" }
const _hoisted_17 = ["onClick", "disabled"]
const _hoisted_18 = { class: "relative group inline-block" }
const _hoisted_19 = ["onClick", "disabled"]
const _hoisted_20 = { class: "relative group inline-block" }
const _hoisted_21 = ["onClick", "disabled"]
const _hoisted_22 = { class: "2xl:hidden divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_23 = { class: "flex items-center justify-between mb-3" }
const _hoisted_24 = { class: "flex items-center space-x-2" }
const _hoisted_25 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_26 = { class: "grid grid-cols-2 gap-3 mb-3" }
const _hoisted_27 = { class: "text-sm text-gray-900 dark:text-white" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = { class: "font-medium text-gray-900 dark:text-white text-sm" }
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = { class: "text-sm text-gray-900 dark:text-white" }
const _hoisted_32 = {
  key: 0,
  class: "flex items-center space-x-2 mb-3"
}
const _hoisted_33 = ["onClick", "disabled"]
const _hoisted_34 = ["onClick", "disabled"]
const _hoisted_35 = { class: "flex items-center space-x-2" }
const _hoisted_36 = ["onClick", "disabled"]
const _hoisted_37 = ["onClick", "disabled"]
const _hoisted_38 = ["onClick", "disabled"]

import type { Claim } from '@/types/claim';
import ViewIcon from '@/components/icons/ViewIcon.vue';
import EditIcon from '@/components/icons/EditIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClaimTable',
  props: {
    claims: {},
    loading: { type: Boolean }
  },
  emits: ["approve", "reject", "view", "edit", "delete"],
  setup(__props: any) {





function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

function getStatusClass(status: string): string {
  switch (status) {
    case 'under review':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
    case 'approved':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
    case 'ready for pick-up':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
    case 'fulfilled':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
  }
}

function getStatusDotClass(status: string): string {
  switch (status) {
    case 'under review':
      return 'bg-yellow-500 dark:bg-yellow-400';
    case 'approved':
      return 'bg-green-500 dark:bg-green-400';
    case 'rejected':
      return 'bg-red-500 dark:bg-red-400';
    case 'ready for pick-up':
      return 'bg-blue-500 dark:bg-blue-400';
    case 'fulfilled':
      return 'bg-purple-500 dark:bg-purple-400';
    default:
      return 'bg-gray-500 dark:bg-gray-400';
  }
}

function getBrandClass(brandName?: string): string {
  switch (brandName?.toLowerCase()) {
    case 'continental':
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400';
    case 'falken':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-black" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Claim Number "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Customer "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Brand "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Tire Pattern "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Date Submitted "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Status "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Actions ")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claims, (claim) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: claim.claim_id,
              class: "transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-600 odd:bg-white even:bg-gray-25 dark:odd:bg-gray-900 dark:even:bg-gray-800"
            }, [
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(claim.claim_number), 1)
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(claim.user?.first_name) + " " + _toDisplayString(claim.user?.last_name), 1)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getBrandClass(claim.brand?.brand_name)])
                }, _toDisplayString(claim.brand?.brand_name || 'N/A'), 3)
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(claim.tire?.pattern), 1)
              ]),
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(formatDate(claim.created_at)), 1)
              ]),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2 sm:px-2.5 py-1 rounded-full text-xs font-medium", getStatusClass(claim.claim_status)])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1 sm:mr-1.5", getStatusDotClass(claim.claim_status)])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(claim.claim_status), 1)
                ], 2)
              ]),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('view', claim)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(ViewIcon, { classes: "h-5 w-5" })
                    ], 8, _hoisted_17),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " View Details ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', claim)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(EditIcon, { classes: "h-5 w-5" })
                    ], 8, _hoisted_19),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Edit Claim ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', claim)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(DeleteIcon, { classes: "h-5 w-5" })
                    ], 8, _hoisted_21),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Delete Claim ", -1))
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claims, (claim) => {
        return (_openBlock(), _createElementBlock("div", {
          key: claim.claim_id,
          class: "p-4 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(claim.claim_number), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getStatusClass(claim.claim_status)])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1.5", getStatusDotClass(claim.claim_status)])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(claim.claim_status), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Customer", -1)),
              _createElementVNode("p", _hoisted_27, _toDisplayString(claim.user?.first_name) + " " + _toDisplayString(claim.user?.last_name), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Brand", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getBrandClass(claim.brand?.brand_name)])
              }, _toDisplayString(claim.brand?.brand_name || 'N/A'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Tire Pattern", -1)),
            _createElementVNode("div", _hoisted_29, _toDisplayString(claim.tire?.pattern), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Date Submitted", -1)),
            _createElementVNode("p", _hoisted_31, _toDisplayString(formatDate(claim.created_at)), 1)
          ]),
          (claim.claim_status === 'under review')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("button", {
                  onClick: _withModifiers(($event: any) => (_ctx.$emit('approve', claim)), ["stop"]),
                  disabled: _ctx.loading,
                  class: "flex-1 inline-flex items-center justify-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-4 w-4 mr-1.5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M5 13l4 4L19 7"
                    })
                  ], -1),
                  _createTextVNode(" Approve ")
                ]), 8, _hoisted_33),
                _createElementVNode("button", {
                  onClick: _withModifiers(($event: any) => (_ctx.$emit('reject', claim)), ["stop"]),
                  disabled: _ctx.loading,
                  class: "flex-1 inline-flex items-center justify-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-4 w-4 mr-1.5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1),
                  _createTextVNode(" Reject ")
                ]), 8, _hoisted_34)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              onClick: _withModifiers(($event: any) => (_ctx.$emit('view', claim)), ["stop"]),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(ViewIcon, { classes: "h-4 w-4 mr-1.5" }),
              _cache[10] || (_cache[10] = _createTextVNode(" View "))
            ], 8, _hoisted_36),
            _createElementVNode("button", {
              onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', claim)), ["stop"]),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 border border-amber-300 dark:border-amber-600 text-sm font-medium rounded-md text-amber-700 dark:text-amber-400 bg-white dark:bg-black hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(EditIcon, { classes: "h-4 w-4 mr-1.5" }),
              _cache[11] || (_cache[11] = _createTextVNode(" Edit "))
            ], 8, _hoisted_37),
            _createElementVNode("button", {
              onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', claim)), ["stop"]),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 border border-red-300 dark:border-red-600 text-sm font-medium rounded-md text-red-700 dark:text-red-400 bg-white dark:bg-black hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(DeleteIcon, { classes: "h-4 w-4 mr-1.5" }),
              _cache[12] || (_cache[12] = _createTextVNode(" Delete "))
            ], 8, _hoisted_38)
          ])
        ]))
      }), 128))
    ])
  ], 64))
}
}

})